(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSBajaDeleteController',SSBajaDeleteController);

    SSBajaDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSBaja'];

    function SSBajaDeleteController($uibModalInstance, entity, SSBaja) {
        var vm = this;

        vm.sSBaja = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSBaja.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
